import _defineProperty from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
import { genFocusStyle, resetComponent, resetIcon } from '../../style';
import { genCollapseMotion } from '../../style/motion';
import { genStyleHooks, mergeToken } from '../../theme/internal';
export var genBaseStyle = function genBaseStyle(token) {
  var componentCls = token.componentCls,
    contentBg = token.contentBg,
    padding = token.padding,
    headerBg = token.headerBg,
    headerPadding = token.headerPadding,
    collapseHeaderPaddingSM = token.collapseHeaderPaddingSM,
    collapseHeaderPaddingLG = token.collapseHeaderPaddingLG,
    collapsePanelBorderRadius = token.collapsePanelBorderRadius,
    lineWidth = token.lineWidth,
    lineType = token.lineType,
    colorBorder = token.colorBorder,
    colorText = token.colorText,
    colorTextHeading = token.colorTextHeading,
    colorTextDisabled = token.colorTextDisabled,
    fontSizeLG = token.fontSizeLG,
    lineHeight = token.lineHeight,
    lineHeightLG = token.lineHeightLG,
    marginSM = token.marginSM,
    paddingSM = token.paddingSM,
    paddingLG = token.paddingLG,
    paddingXS = token.paddingXS,
    motionDurationSlow = token.motionDurationSlow,
    fontSizeIcon = token.fontSizeIcon,
    contentPadding = token.contentPadding,
    fontHeight = token.fontHeight,
    fontHeightLG = token.fontHeightLG;
  var borderBase = "".concat(unit(lineWidth), " ").concat(lineType, " ").concat(colorBorder);
  return _defineProperty({}, componentCls, Object.assign(Object.assign({}, resetComponent(token)), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    backgroundColor: headerBg,
    border: borderBase,
    borderRadius: collapsePanelBorderRadius,
    '&-rtl': {
      direction: 'rtl'
    }
  }, "& > ".concat(componentCls, "-item"), _defineProperty(_defineProperty(_defineProperty({
    borderBottom: borderBase,
    '&:first-child': _defineProperty({}, "\n            &,\n            & > ".concat(componentCls, "-header"), {
      borderRadius: "".concat(unit(collapsePanelBorderRadius), " ").concat(unit(collapsePanelBorderRadius), " 0 0")
    }),
    '&:last-child': _defineProperty({}, "\n            &,\n            & > ".concat(componentCls, "-header"), {
      borderRadius: "0 0 ".concat(unit(collapsePanelBorderRadius), " ").concat(unit(collapsePanelBorderRadius))
    })
  }, "> ".concat(componentCls, "-header"), Object.assign(Object.assign({
    position: 'relative',
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
    padding: headerPadding,
    color: colorTextHeading,
    lineHeight: lineHeight,
    cursor: 'pointer',
    transition: "all ".concat(motionDurationSlow, ", visibility 0s")
  }, genFocusStyle(token)), _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "> ".concat(componentCls, "-header-text"), {
    flex: 'auto'
  }), "".concat(componentCls, "-expand-icon"), {
    height: fontHeight,
    display: 'flex',
    alignItems: 'center',
    paddingInlineEnd: marginSM
  }), "".concat(componentCls, "-arrow"), Object.assign(Object.assign({}, resetIcon()), {
    fontSize: fontSizeIcon,
    // when `transform: rotate()` is applied to icon's root element
    transition: "transform ".concat(motionDurationSlow),
    // when `transform: rotate()` is applied to icon's child element
    svg: {
      transition: "transform ".concat(motionDurationSlow)
    }
  })), "".concat(componentCls, "-header-text"), {
    marginInlineEnd: 'auto'
  }))), "".concat(componentCls, "-collapsible-header"), _defineProperty({
    cursor: 'default'
  }, "".concat(componentCls, "-header-text"), {
    flex: 'none',
    cursor: 'pointer'
  })), "".concat(componentCls, "-collapsible-icon"), _defineProperty({
    cursor: 'unset'
  }, "".concat(componentCls, "-expand-icon"), {
    cursor: 'pointer'
  }))), "".concat(componentCls, "-content"), _defineProperty(_defineProperty({
    color: colorText,
    backgroundColor: contentBg,
    borderTop: borderBase
  }, "& > ".concat(componentCls, "-content-box"), {
    padding: contentPadding
  }), '&-hidden', {
    display: 'none'
  })), '&-small', _defineProperty({}, "> ".concat(componentCls, "-item"), _defineProperty(_defineProperty({}, "> ".concat(componentCls, "-header"), _defineProperty({
    padding: collapseHeaderPaddingSM,
    paddingInlineStart: paddingXS
  }, "> ".concat(componentCls, "-expand-icon"), {
    // Arrow offset
    marginInlineStart: token.calc(paddingSM).sub(paddingXS).equal()
  })), "> ".concat(componentCls, "-content > ").concat(componentCls, "-content-box"), {
    padding: paddingSM
  }))), '&-large', _defineProperty({}, "> ".concat(componentCls, "-item"), _defineProperty(_defineProperty({
    fontSize: fontSizeLG,
    lineHeight: lineHeightLG
  }, "> ".concat(componentCls, "-header"), _defineProperty({
    padding: collapseHeaderPaddingLG,
    paddingInlineStart: padding
  }, "> ".concat(componentCls, "-expand-icon"), {
    height: fontHeightLG,
    // Arrow offset
    marginInlineStart: token.calc(paddingLG).sub(padding).equal()
  })), "> ".concat(componentCls, "-content > ").concat(componentCls, "-content-box"), {
    padding: paddingLG
  }))), "".concat(componentCls, "-item:last-child"), _defineProperty({
    borderBottom: 0
  }, "> ".concat(componentCls, "-content"), {
    borderRadius: "0 0 ".concat(unit(collapsePanelBorderRadius), " ").concat(unit(collapsePanelBorderRadius))
  })), "& ".concat(componentCls, "-item-disabled > ").concat(componentCls, "-header"), _defineProperty({}, "\n          &,\n          & > .arrow\n        ", {
    color: colorTextDisabled,
    cursor: 'not-allowed'
  })), "&".concat(componentCls, "-icon-position-end"), _defineProperty({}, "& > ".concat(componentCls, "-item"), _defineProperty({}, "> ".concat(componentCls, "-header"), _defineProperty({}, "".concat(componentCls, "-expand-icon"), {
    order: 1,
    paddingInlineEnd: 0,
    paddingInlineStart: marginSM
  }))))));
};
var genArrowStyle = function genArrowStyle(token) {
  var componentCls = token.componentCls;
  var fixedSelector = "> ".concat(componentCls, "-item > ").concat(componentCls, "-header ").concat(componentCls, "-arrow");
  return _defineProperty({}, "".concat(componentCls, "-rtl"), _defineProperty({}, fixedSelector, {
    transform: "rotate(180deg)"
  }));
};
var genBorderlessStyle = function genBorderlessStyle(token) {
  var componentCls = token.componentCls,
    headerBg = token.headerBg,
    paddingXXS = token.paddingXXS,
    colorBorder = token.colorBorder;
  return _defineProperty({}, "".concat(componentCls, "-borderless"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    backgroundColor: headerBg,
    border: 0
  }, "> ".concat(componentCls, "-item"), {
    borderBottom: "1px solid ".concat(colorBorder)
  }), "\n        > ".concat(componentCls, "-item:last-child,\n        > ").concat(componentCls, "-item:last-child ").concat(componentCls, "-header\n      "), {
    borderRadius: 0
  }), "> ".concat(componentCls, "-item:last-child"), {
    borderBottom: 0
  }), "> ".concat(componentCls, "-item > ").concat(componentCls, "-content"), {
    backgroundColor: 'transparent',
    borderTop: 0
  }), "> ".concat(componentCls, "-item > ").concat(componentCls, "-content > ").concat(componentCls, "-content-box"), {
    paddingTop: paddingXXS
  }));
};
var genGhostStyle = function genGhostStyle(token) {
  var componentCls = token.componentCls,
    paddingSM = token.paddingSM;
  return _defineProperty({}, "".concat(componentCls, "-ghost"), _defineProperty({
    backgroundColor: 'transparent',
    border: 0
  }, "> ".concat(componentCls, "-item"), _defineProperty({
    borderBottom: 0
  }, "> ".concat(componentCls, "-content"), _defineProperty({
    backgroundColor: 'transparent',
    border: 0
  }, "> ".concat(componentCls, "-content-box"), {
    paddingBlock: paddingSM
  }))));
};
export var prepareComponentToken = function prepareComponentToken(token) {
  return {
    headerPadding: "".concat(token.paddingSM, "px ").concat(token.padding, "px"),
    headerBg: token.colorFillAlter,
    contentPadding: "".concat(token.padding, "px 16px"),
    // Fixed Value
    contentBg: token.colorBgContainer
  };
};
export default genStyleHooks('Collapse', function (token) {
  var collapseToken = mergeToken(token, {
    collapseHeaderPaddingSM: "".concat(unit(token.paddingXS), " ").concat(unit(token.paddingSM)),
    collapseHeaderPaddingLG: "".concat(unit(token.padding), " ").concat(unit(token.paddingLG)),
    collapsePanelBorderRadius: token.borderRadiusLG
  });
  return [genBaseStyle(collapseToken), genBorderlessStyle(collapseToken), genGhostStyle(collapseToken), genArrowStyle(collapseToken), genCollapseMotion(collapseToken)];
}, prepareComponentToken);